/* tslint:disable no-string-literal */
import { Component, OnInit, Input, Output, EventEmitter, Renderer2, Inject, ViewChild, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { JobPointeTransferService } from 'src/app/component/job-pointe/job-pointe-transfer/job-pointe-transfer.service';
import { JobsService } from 'src/app/service/jobs/jobs.service';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { DOCUMENT } from '@angular/common';
import {
  AutoCompleteFetchModel,
  AutoCompleteSelectModel,
} from 'src/app/component/shared/autocomplete/autocomplete.model';
import { JobPointeService } from 'src/app/service/job-pointe/job-pointe.service';
import { JobParams } from '../../../job-pointe/job-pointe-transfer/job-pointe-transfer.model';
import { PermissionsService } from 'src/app/service/auth/permissions.service';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import { SearchParams } from 'src/app/shared/types/SearchBarParams';

@Component({
  selector: 'app-job-pointe-settings-bar',
  templateUrl: './job-pointe-settings-bar.component.html',
  styleUrls: ['./job-pointe-settings-bar.component.scss'],
})
export class JobPointeSettingsBarComponent implements OnInit, OnChanges {
  @ViewChild('departmentsFilter') departmentsFilter;
  @ViewChild('rolesFilter') rolesFilter;
  @ViewChild('employeeTitlesFilter') employeeTitlesFilter;
  @ViewChild('employeeGroupsFilter') employeeGroupsFilter;
  @ViewChild('statusFilter') statusFilter;
  @ViewChild('localsFilter') localsFilter;
  @ViewChild('jobsAutocomplete') jobsAutocomplete;
  @ViewChild('jobCitiesFilter') jobCitiesFilter;
  @ViewChild('projectManagersFilter') projectManagersFilter;
  @ViewChild('jobAssistantsFilter') jobAssistantsFilter;
  @ViewChild('jobForemanFilter') jobForemanFilter;
  @ViewChild('employeesFilter') employeesFilter;
  @ViewChild('hubStatusFilter') hubStatusFilter;
  @ViewChild('ownerFilter') ownerFilter;
  @ViewChild('date_worked') date_worked;
  @ViewChild('jobBoardAttributesFilter') jobBoardAttributesFilter;
  @ViewChild('facilityFilter') facilityFilter;
  @ViewChild('employeeUnionClassesFilter') employeeUnionClassesFilter;
  @ViewChild('defaultStartYearFilter') defaultStartYearFilter;
  @ViewChild('jobBoardTagsFilter') jobBoardTagsFilter;
  @ViewChild('unionFilter') unionFilter;
  jobParams = JobParams;

  @Input() searchBarSide = 'right';
  @Input() editAccess = true;
  @Input() jobPointeSettingsData: any;
  @Input() filters: Array<any> = [];
  @Input() moreFilters: Array<any> = [];
  @Input() source: string;
  @Output() search = new EventEmitter<SearchParams>();
  @Output() create = new EventEmitter<string>();
  @Output() filter = new EventEmitter<any>();
  @Output() transfer = new EventEmitter<any>();
  @Output() action = new EventEmitter<any>();
  @Output() clear = new EventEmitter<any>();
  @Output() exportEmployees = new EventEmitter<any>();

  filterType: string;
  searchFilters: any = {};
  selectedItems: Array<any> = [];
  searchInput = '';
  subscription: Subscription;
  list;
  exportType: string;
  selectedDateRange: any = '';
  assignmentFilterProps = {};
  rentalRatesIncluded: boolean = false;
  stickyFilterProperties = ['scope[defaultStartYear]'];
  dependentFilterProperties = {
    'scope[jobBoardFacilityOwners]': { facility: 'ownerId' },
    'scope[facilityOwners]': { facility: 'ownerId' },
  };
  tempFilterOptions: Array<any> = [];

  constructor(
    private jobPointeTransferService: JobPointeTransferService,
    private jobPointeService: JobPointeService,
    private localStorageService: LocalstorageService,
    /* tslint:disable-next-line variable-name */
    @Inject(DOCUMENT) public _document,
    public renderer2: Renderer2,
    public permissionsService: PermissionsService,
    private loaderService: LoaderService,
    private toastService: ToastService,
    private momentService: MomentService,
    private jobsService: JobsService,
  ) { }

  ngOnInit(): void {
    this.getTableFilters();
    this.jobPointeTransferService.loadFromLocalStorage();
    this.subscription = this.jobPointeTransferService.selectedItems.subscribe(data => (this.selectedItems = data));
    this.loadOptionsData();
    if (this.moreFilters) this.loadMoreOptionsData();
    this.loadSelect2();
    setTimeout(() => this.loadSelect2MultipleWithCheck(), 700);
  }

  capitalize(word) {
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  }

  isAllowed(resource: string, action: string) {
    const resources = {
      employees: 'job_pointe_employees',
      manage_jobs: 'manage_jobs',
    };
    const resource1 = resources[resource];
    return this.permissionsService.allow({ resource1, action });
  }

  loadSelect2MultipleWithCheck(className = '.select2MultipleWithCheck') {
    const s1 = this.renderer2.createElement('script');
    s1.type = 'text/javascript';
    s1.text = `loadSelect2MultipleWithCheck('` + className + `','Status');`;
    this.renderer2.appendChild(this._document.body, s1);
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  ngOnChanges() {
    this.filterType =
      this.source === 'employees'
        ? 'employeeFilter'
        : this.source === 'configurations'
          ? 'configurationFilter'
          : this.source === 'manageJobs'
            ? 'manageJobsFilter'
            : this.source === 'jobBoardEmployees'
              ? 'jobBoardEmployeesFilter'
              : this.source === 'jobBoard'
                ? 'jobBoardFilter'
                : this.source;

    if (this.filterType) {
      const filterData = this.localStorageService.getItem(this.filterType);
      if (filterData) {
        this.searchFilters = JSON.parse(filterData);
      }
    }
    if (this.source === 'configurations' && this.searchFilters) {
      this.searchFilters['scope[enabled]'] = true;
      this.filter.emit(this.searchFilters);
      return;
    }

    this.filter.emit(this.searchFilters);
  }

  async loadOptionsData() {
    const promiseList = this.filters.map(async filter => {
      if (typeof filter.loadOptions === 'function') {
        const options = await filter.loadOptions();
        filter.options = options;
      }
    });
    await Promise.all(promiseList);
  }

  handleSave(e) { }

  async loadMoreOptionsData() {
    const promiseList = this.moreFilters.map(async filter => {
      if (typeof filter.loadOptions === 'function') {
        const options = await filter.loadOptions();
        filter.options = options;
      }
    });
    await Promise.all(promiseList);
  }

  getTableFilters() {
    const filters = ['assistants', 'foremans', 'managers'];
    this.jobsService.getJobTableFilters(filters).subscribe(
      res => this.onFiltersSuccess(res),
      err => this.onFiltersError(err),
    );
  }

  onFiltersSuccess(result) {
    if (!result?.data) return null;
  }

  onFiltersError(error: unknown) {
    console.error('GET Table Filters Error:', error);
  }

  checkIsSelected(id, type) {
    const searchData = this.searchFilters[type];
    return searchData && searchData.includes(id);
  }

  includeRentalRatesChecked(event) {
    if (event.target.checked) {
      this.searchFilters['scope[hasRentalRates]'] = true;
    } else {
      this.searchFilters['scope[hasRentalRates]'] = '';
    }

    this.filter.emit(this.searchFilters);
  }

  clearFilter() {
    this.localStorageService.removeItem(this.filterType);
    this.localStorageService.removeItem('selected-jobs');

    Object.keys(this.searchFilters).forEach(key => {
      if (!this.stickyFilterProperties.includes(key)) {
        this.searchFilters[key] = '';
      } else {
        this.saveStickyFilters(key);
      }
    });

    this.filters.map(async filter => {
      filter.default = '';
    });

    if (this.moreFilters) {
      this.moreFilters.map(async filter => {
        filter.default = '';
      });
    }

    if (this.filterType === 'employeeFilter') {
      this.departmentsFilter.clearFilter();
      this.employeeTitlesFilter.clearFilter();
      this.employeeGroupsFilter.clearFilter();
      this.statusFilter.clearFilter();
      this.localsFilter.clearFilter();
      this.ownerFilter.clearFilter();
      this.facilityFilter.clearFilter();
      if (this.jobBoardAttributesFilter) this.jobBoardAttributesFilter.clearFilter();
    } else if (this.filterType === 'jobBoardFilter') {
      this.departmentsFilter.clearFilter();
      this.jobBoardAttributesFilter.clearFilter();
      this.jobBoardTagsFilter.clearFilter();
      this.projectManagersFilter.clearFilter();
      this.jobsAutocomplete.clearFilter();
      this.ownerFilter.clearFilter();
      this.facilityFilter.clearFilter();
    } else if (this.filterType === 'jobBoardEmployeesFilter') {
      this.employeeUnionClassesFilter.clearFilter();
      this.departmentsFilter.clearFilter();
      this.employeeTitlesFilter.clearFilter();
      this.statusFilter.clearFilter();
      this.jobBoardAttributesFilter.clearFilter();
    } else if (this.filterType === 'manageJobsFilter') {
      this.projectManagersFilter.clearFilter();
      this.jobAssistantsFilter.clearFilter();
      this.jobForemanFilter.clearFilter();
      this.employeesFilter.clearFilter();
      this.statusFilter.clearFilter();
      this.hubStatusFilter.clearFilter();
      this.ownerFilter.clearFilter();
    }

    // Prevent other events for jobBoardFilter, handled separately for job board
    if (this.filterType !== 'jobBoardFilter' && this.filterType !== 'employeeFilter') {
      this.filter.emit(this.searchFilters);
    }

    if (this.filterType === 'employeeFilter') {
      // On "clear", set status filter to active employees.
      this.statusFilter.selectedItems = [1]
    }

    this.searchInput = '';
    this.clear.emit();
    this.search.emit({ search: '' });
    this.jobPointeService.filtersClearedSource.next({
      filterType: this.filterType,
    });
    this.toastService.showToast('Filters cleared successfully', 'success');
  }

  jobPointeIdSearch(event: KeyboardEvent) {
    const { value } = event.target as HTMLInputElement;
    this.jobPointeService.read['employees']({ search: value }).subscribe(res => {
      this.filters.filter(f => f.model === 'employees')[0].options = res.data;
    });
  }

  triggerChange(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `triggerChangeWithValue('` + obj + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  clearSelect2MultipleWithCheck(className = '.select2MultipleWithCheck') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearSelect2MultipleWithCheck('` + className + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  setSelect2MultipleWithCheck(className = '.select2MultipleWithCheck', searchInfo = {}) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `setSelect2MultipleWithCheck('` + className + `', [` + searchInfo['status'] + `]);`;
    this.renderer2.appendChild(this._document.body, s);
    const s1 = this.renderer2.createElement('script');
    s1.type = 'text/javascript';
    s1.text = `setSelect2MultipleWithCheck('` + className + `', [` + searchInfo['assetClasses'] + `]);`;
    this.renderer2.appendChild(this._document.body, s1);
  }

  onSearchAction() {
    if (this.jobPointeSettingsData.type !== 'employees') {
      this.submitSearch();
    }
    this.submitEmployeeSearch();
  }

  submitSearch(): void {
    if (this.jobPointeSettingsData.type === 'employees') {
      this.search.emit({
        // 'scope[status]': '1',
        search: this.searchInput,
      });
      return;
    }

    this.search.emit({
      search: this.searchInput,
    });
  }

  submitEmployeeSearch(): void {
    this.search.emit({
      search: this.searchInput,
    });
  }

  submitCreate(): void {
    this.create.emit(this.jobPointeSettingsData.type);
  }

  viewArchivedJobs() { }

  addEmployee() {
    this.jobPointeTransferService.addEmployeeModalIsOpenSource.next(true);
  }

  // by default, the option.id property will be used as the value
  // for options in a <select> tag. If a custom property is assigned
  // to the filter.value, this method determines which property
  // should be used for the value of the option
  getOptionValue(filter: any, option: any): any {
    return filter.value ? option[filter.value] : option.id;
  }

  submitFilters(property: string, event: any): void {
    if (event.target.value && event.target.value !== 'null') {
      this.searchFilters[property] = event.target.value;
      this.filter.emit(this.searchFilters);
    } else {
      this.searchFilters[property] = '';
      this.filter.emit(this.searchFilters);
    }
  }

  submitMultipleFilter(property: string, event: any): void {
    if (event.target.value && event.target.value !== 'null') {
      this.searchFilters[property] = event.target.value;
      this.filter.emit(this.searchFilters);
    } else {
      this.searchFilters[property] = '';
      this.filter.emit(this.searchFilters);
    }
  }

  submitDaterangeFilter(property, data): void {
    if (!data.start && !data.end) {
      this.clearDaterangeFilter(property);
      return;
    }
    this.searchFilters[property] = `${this.momentService.getDBDateFormat(
      data.start.toString(),
    )},${this.momentService.getDBDateFormat(data.end.toString())}`;
    this.filter.emit(this.searchFilters);
  }

  clearDaterangeFilter(property) {
    if (this.searchFilters[property]) {
      this.searchFilters[property] = '';
      this.filter.emit(this.searchFilters);
    }
  }

  updateMultiselectDependentFilter(
    dependentFilterModel: String,
    masterFilterProperty: any,
    selectedMasterOptions: Array<any>,
  ) {
    let dependentFilter = this.filters.find(f => f.model == dependentFilterModel);
    if (this.tempFilterOptions.length) {
      dependentFilter.options = this.tempFilterOptions;
    } else {
      this.tempFilterOptions = dependentFilter.options;
    }
    if (selectedMasterOptions.length) {
      dependentFilter.options = dependentFilter.options.filter(o =>
        selectedMasterOptions.includes(o?.[masterFilterProperty]),
      );
    } else {
      dependentFilter.loadOptions();
      this.tempFilterOptions = [];
    }
  }

  saveStickyFilters(property) {
    if (this.stickyFilterProperties.includes(property)) {
      const filters = JSON.parse(this.localStorageService.getItem(this.filterType));
      this.localStorageService.setItem(
        this.filterType,
        JSON.stringify({
          ...filters,
          [property]: this.searchFilters[property],
        }),
      );
    }
  }

  submitSingleFilter(property, data): void {
    if (typeof data === 'object' && data !== null) data = !Object.keys(data).length ? null : data;
    if (data) {
      //multi-dimensional filter props (Assignments)
      if (data?.value && data?.propertyType) {
        this.assignmentFilterProps[property] = data.propertyType;
        this.searchFilters[`${property}[${data.propertyType}]`] = data.value;
        this.filter.emit(this.searchFilters);
      } else {
        //single-dimensional filter props (Assignments)
        if (data?.value) {
          this.searchFilters[property] = data.value;
          this.filter.emit(this.searchFilters);
        } else {
          //Normal filters
          this.searchFilters[property] = data;
          this.filter.emit(this.searchFilters);
        }
      }
    } else {
      //filter data empty
      if (this.assignmentFilterProps?.[property]) {
        //clearing multi-dimensional filter props
        const propertyType = this.assignmentFilterProps[property];
        this.searchFilters[`${property}[${propertyType}]`] = typeof data === 'boolean' ? 'false' : '';
      } else {
        //clearing normal filter props
        this.searchFilters[property] = typeof data === 'boolean' ? 'false' : data;
      }
      this.filter.emit(this.searchFilters);
    }
    //Set sticky default filters to local storage
    this.saveStickyFilters(property);
  }

  submitAutocompleteMultipleFilter(property, data): void {
    //Handle dependent filter changes
    if (this.dependentFilterProperties?.[property]) {
      const dependentFilterModel = this.dependentFilterProperties?.[property];
      Object.entries(dependentFilterModel).forEach(([model, masterProperty]) => {
        this.updateMultiselectDependentFilter(model, masterProperty, data);
      });
    }
    if (Array.isArray(data) && data.length) {
      this.searchFilters[property] = data.toString();
      this.filter.emit(this.searchFilters);
    } else {
      this.searchFilters[property] = '';
      this.filter.emit(this.searchFilters);
    }
  }

  get autoCompleteMap() {
    return {
      jobs: this.jobsAutocomplete,
    };
  }

  get paramsMap() {
    return {
      jobs: this.jobParams,
    };
  }

  fetch(model: AutoCompleteFetchModel) {
    const { namespace, search } = model;
    const autocomplete = this.autoCompleteMap[namespace];
    let params = this.paramsMap[namespace];
    params = { ...params, search };
    this.jobPointeService.list[namespace](params).subscribe(res => {
      autocomplete.fetchSuccessHandler(res);
    });
  }

  fetchNext(model: AutoCompleteFetchModel) {
    const { namespace, page } = model;
    const autocomplete = this.autoCompleteMap[namespace];
    let params = this.paramsMap[namespace];
    params = { ...params, page };
    this.jobPointeService.list[namespace](params).subscribe(res => {
      autocomplete.fetchNextSuccessHandler(res);
    });
  }

  submitAutoCompleteFilter(model: AutoCompleteSelectModel) {
    const { item, id } = model;
    this.searchFilters[id] = item.id;
    this.filter.emit(this.searchFilters);
  }

  saveFilter() {
    this.localStorageService.setItem(this.filterType, JSON.stringify(this.searchFilters));
    this.filter.emit(this.searchFilters);
    this.toastService.showToast('Filters saved successfully ', 'success');
  }

  emitTransfer() {
    this.transfer.emit();
  }

  emitAction(actionType) {
    this.action.emit({ action: actionType, payload: this.selectedItems });
  }

  setJobPointeExportType(type: string) {
    this.exportType = type;
  }

  loadDatePicker(className = null, altField = null) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    if (className != null) {
      s.text = `loadDatePicker('` + className + `','` + altField + `');`;
    } else {
      s.text = `loadDatePicker()`;
    }
    this.renderer2.appendChild(this._document.body, s);
  }

  emitCertsTagsExport(exportType: string) {
    this.exportType = exportType;
    this.searchFilters['scope[hasEmployeeId]'] = true;

    if (!this.searchFilters['scope[status]']) {
      this.searchFilters['scope[status]'] = 1;
    }

    this.filter.emit(this.searchFilters);
    this.searchFilters = {};

    this.exportEmployees.emit({
      exportType: exportType,
      embed:
        'employeeDepartment,employeeUnionLocal,employeeTitle,employeeJobBoardAttributes,employeeJobBoardTags,employeeHomeLocal',
    });
  }

  emitExport(scope?: string) {
    this.loaderService.displayLoader();

    if (scope) {
      this.searchFilters[`scope[${scope}]`] = true;
      this.filter.emit(this.searchFilters);

      if (scope === 'activeEmployees') {
        this.exportType = 'active';
      }
    }

    this.exportEmployees.emit({
      exportType: this.exportType,
      order: scope === 'activeEmployees' ? 'employeeId,ASC' : 'employeeAlias,ASC',
    });
  }
}
